// Shared context so individual widgets can read dashboard state (Personalise
// mode) and their own persisted per-user prefs without prop drilling.
import { createContext, useContext } from 'react';

export const DashboardWidgetContext = createContext({
  editMode: false,
  prefs: {},
  setWidgetPrefs: () => {},
});

// { editMode, myPrefs, setMyPrefs } for one widget id.
export function useWidgetContext(widgetId) {
  const { editMode, prefs, setWidgetPrefs } = useContext(DashboardWidgetContext);
  return {
    editMode,
    myPrefs: (prefs && prefs[widgetId]) || {},
    setMyPrefs: (patch) => setWidgetPrefs(widgetId, patch),
  };
}
